import { countryFromHost } from 'shared/country'
import { SEARCH_MODE_HOURLY, SEARCH_MODE_MONTHLY } from 'search/constants'

export const THEME = {
    WESTPARK: 'westpark',
    INDIGO: 'indigo',
    SABA: 'saba',
    OPENGO: 'opengo',
}

export const ENV_THEME = THEME.INDIGO

export const getPOIIcon = poiType => {
    switch (poiType) {
        case 'tour':
            return 'building'
        case 'commerce':
            return 'shoping'
        default:
            return 'building'
    }
}

export const getPinIcon = ({ theme = ENV_THEME, faded, active, bookable }) => {
    if (theme === THEME.OPENGO) {
        return 'map-pin-opngo'
    }
    return `${theme}-${bookable ? 'bookable' : 'unbookable'}-${faded ? 'faded' : active ? 'active' : 'general'}`
}

export const getClusterIcon = ({ theme = ENV_THEME, faded }) => `${theme}-cluster-${faded ? 'faded' : 'general'}`

export const Point = ({ x, y }) => ({
    type: 'Point',
    coordinates: [y, x],
})

export const Feature = (clusterId, { id, geoLocation }) => ({
    id: clusterId,
    type: 'Feature',
    geometry: {
        ...Point(geoLocation),
    },
    properties: {
        id,
    },
})

export const getDefaultCoordinates = (country = countryFromHost()) =>
    ({
        uk: {
            // London
            lat: 51.51509656653488,
            lng: -0.08552930126950287,
        },
        ca: {
            // Ottawa
            lat: 45.421983,
            lng: -75.695691,
        },
        be: {
            // Brussels
            lat: 50.847722,
            lng: 4.351125,
        },
        es: {
            // Madrid
            lat: 40.416664,
            lng: -3.70375,
        },
        cz: {
            // Prague
            lat: 50.074801,
            lng: 14.437167,
        },
        sk: {
            // Bratislava
            lat: 48.148386,
            lng: 17.107148,
        },
        lu: {
            // Luxembourg
            lat: 49.6110312,
            lng: 6.1293533,
        },
        de: {
            // Berlin
            lat: 52.519921,
            lng: 13.404746,
        },
        us: {
            // Chicago
            lat: 41.8781,
            lng: -87.6298,
        },
        br: {
            // Rio de Janeiro city ceenter
            lat: -22.906811902384387,
            lng: -43.18352586316361,
        },
    }[country])

// Need to compare bounding box longitudes
// since the map bounding box is in range 180 to -180
const isLongInRange = (bounds, point) => {
    if (bounds.ne.lng < bounds.sw.lng) {
        return (point.lng || point.y) >= bounds.sw.lng || (point.lng || point.y) <= bounds.ne.lng
    } else return (point.lng || point.y) >= bounds.sw.lng && (point.lng || point.y) <= bounds.ne.lng
}

// To check whether a point in map is in given bounds
export const isPointInBounds = (bounds, point) =>
    !bounds || !point
        ? undefined
        : (point.lat || point.x) >= bounds.sw.lat &&
          (point.lat || point.x) <= bounds.ne.lat &&
          isLongInRange(bounds, point)

// To compare if one bound is equal or contained by the other
export const isBoundInBounds = (currentBounds, existingBounds) =>
    currentBounds &&
    existingBounds &&
    currentBounds.nw.lat <= existingBounds.nw.lat &&
    currentBounds.nw.lng >= existingBounds.nw.lng &&
    currentBounds.se.lat >= existingBounds.se.lat &&
    currentBounds.se.lng <= existingBounds.se.lng

export const getLocationsInBounds = (locations, bounds) =>
    Object.keys(locations).filter(location => isPointInBounds(bounds, locations[location].geoLocation))

export const getInitSearchMode = country => {
    switch (country) {
        case 'BR':
            return SEARCH_MODE_MONTHLY
        default:
            return SEARCH_MODE_HOURLY
    }
}
